import type { ApiListRequest, ApiListResponseV3 } from "../@types/services/Api";
import type { Term, TermsFilter } from "../@types/services/Term";
import type { TermDocument } from "../@types/services/TermDocument";
import { api } from "./api";
import { createTermDocument } from "./termDocuments";

const API_BASE_URL = "/api/v3/terms";

export type NewTermForm = {
  name_pt_br: string;
  name_en: string;
  mandatory: boolean;
  active: boolean;
  term_types: string[];
  attachment_pt_br: string;
  attachment_en: string;
};

export type TermInputForm = {
  name_pt_br: string;
  name_en: string;
  mandatory: boolean;
  active: boolean;
  term_types: string[];
};

export const fetchTerms = async ({
  filters,
  ...rest
}: ApiListRequest<TermsFilter> = {}): Promise<ApiListResponseV3<Term>> => {
  const response = await api.get<ApiListResponseV3<Term>>("", {
    baseURL: API_BASE_URL,
    params: {
      ...filters,
      ...rest,
    },
  });

  return response.data;
};

export const fetchTerm = async (id: Term["id"]): Promise<Term> => {
  const response = await api.get<Term>(`/${id}`, {
    baseURL: API_BASE_URL,
  });

  return response.data;
};

export const createTerm = async (data: NewTermForm): Promise<Term> => {
  const {
    attachment_pt_br: attachmentPtBr,
    attachment_en: attachmentEn,
    ...termAttrs
  } = data;

  const response = await api.post<Term>("", termAttrs, {
    baseURL: API_BASE_URL,
  });

  await createTermDocument({
    attachment_en: attachmentEn,
    attachment_pt_br: attachmentPtBr,
    justification: "First version of term",
    term_id: response.data.id,
  });

  return response.data;
};

export const updateTerm = async (
  id: Term["id"],
  data: TermInputForm,
): Promise<Term> => {
  const response = await api.patch<Term>(`/${id}`, data, {
    baseURL: API_BASE_URL,
  });

  return response.data;
};

export const fetchActiveTermDocument = async (
  id: Term["id"],
): Promise<TermDocument> => {
  const response = await api.get<TermDocument>(`/${id}/active_term_document`, {
    baseURL: API_BASE_URL,
  });

  return response.data;
};

export const fetchArchivedTermDocuments = async (
  id: Term["id"],
): Promise<TermDocument[]> => {
  const response = await api.get<TermDocument[]>(
    `/${id}/archived_term_documents`,
    {
      baseURL: API_BASE_URL,
    },
  );

  return response.data;
};
